<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="180" height="66" viewBox="0 0 180 66">
		<defs>
			<linearGradient id="linear-gradient" x1="0.5" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
				<stop offset="0" stop-color="#fff" />
				<stop offset="1" stop-color="#fff" stop-opacity="0" />
			</linearGradient>
		</defs>
		<g id="그룹_21492" data-name="그룹 21492" transform="translate(-1404 -338)">
			<g id="그룹_21435" data-name="그룹 21435" transform="translate(1404.468 351.201)">
				<g id="그룹_19457" data-name="그룹 19457" transform="translate(0)">
					<rect
						id="사각형_5814"
						data-name="사각형 5814"
						width="53"
						height="53"
						transform="translate(-0.468 -0.201)"
						fill="red"
						opacity="0"
					/>
					<g id="그룹_19460" data-name="그룹 19460" transform="translate(10.508 8.756)">
						<g id="point_hand" data-name="point hand">
							<path
								id="패스_560"
								data-name="패스 560"
								d="M2436.254,1367.757V1362.5a3.513,3.513,0,0,0-3.5-3.5H2431v8.757"
								transform="translate(-2415.239 -1351.995)"
								fill="none"
								stroke="#fff"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
							<path
								id="패스_561"
								data-name="패스 561"
								d="M2439.254,1364.5a3.513,3.513,0,0,0-3.5-3.5H2434"
								transform="translate(-2412.985 -1350.492)"
								fill="none"
								stroke="#fff"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
							<path
								id="패스_562"
								data-name="패스 562"
								d="M2442.254,1368.254V1366.5a3.513,3.513,0,0,0-3.5-3.5H2437v1.751"
								transform="translate(-2410.731 -1348.99)"
								fill="none"
								stroke="#fff"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
							<path
								id="패스_563"
								data-name="패스 563"
								d="M2453.523,1374.264c0,7.005-3.5,7.005-3.5,14.01h-19.264c0-8.756-8.757-10.508-8.757-14.01v-8.756a1.752,1.752,0,0,1,1.751-1.751h0a3.513,3.513,0,0,1,3.5,3.5v1.751c0,.979,5.254,2.473,5.254,1.507v-12.89a2.627,2.627,0,1,1,5.253,0v4.378"
								transform="translate(-2422 -1355)"
								fill="none"
								stroke="#fff"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
							/>
						</g>
						<rect
							id="사각형_5813"
							data-name="사각형 5813"
							width="23"
							height="8"
							transform="translate(7.024 33.043)"
							fill="none"
							stroke="#fff"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
						/>
					</g>
					<path
						id="패스_17735"
						data-name="패스 17735"
						d="M129.9,0a9.91,9.91,0,0,1,9.9,9.9,1.414,1.414,0,1,1-2.828,0,7.071,7.071,0,1,0-14.142,0A1.414,1.414,0,1,1,120,9.9,9.91,9.91,0,0,1,129.9,0Zm0,0"
						transform="translate(-106.595)"
						fill="#fff"
					/>
				</g>
			</g>
			<g id="그룹_21477" data-name="그룹 21477" transform="translate(1440.11 338)">
				<g id="그룹_3754" data-name="그룹 3754" transform="translate(26.402 26.402) rotate(180)">
					<rect id="사각형_626" data-name="사각형 626" width="27" height="26" transform="translate(-0.488 0.402)" fill="red" opacity="0" />
					<path id="다각형_1" data-name="다각형 1" d="M10.5,0,21,17H0Z" transform="translate(22.512 2.402) rotate(90)" fill="#fff" />
				</g>
				<path
					id="패스_17736"
					data-name="패스 17736"
					d="M0-3,124.088.96V8.881L0,12.841Z"
					transform="translate(19.801 8.28)"
					fill="url(#linear-gradient)"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {};
</script>

<style>
</style>
